import { render, staticRenderFns } from "./PresentationBlock.vue?vue&type=template&id=9fde66c0&scoped=true"
import script from "./PresentationBlock.vue?vue&type=script&lang=js"
export * from "./PresentationBlock.vue?vue&type=script&lang=js"
import style0 from "./PresentationBlock.vue?vue&type=style&index=0&id=9fde66c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fde66c0",
  null
  
)

export default component.exports